import { style, keyframes, globalStyle } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { reducedMotion, mobile } from '../../theme/media';
import { glassPanelBase } from '../../styles/glass.css';

const fadeInUp = keyframes({
  from: { opacity: 0, transform: 'translateY(8px)' },
  to: { opacity: 1, transform: 'translateY(0)' },
});

export const container = style({
  ...glassPanelBase,
  display: 'flex',
  alignItems: 'flex-start',
  gap: vars.spacing.gap.sm,
  padding: vars.spacing.padding.md,
  border: `1px solid ${vars.surface.liquidGlass.innerSurface.border}`,
  borderLeft: `3px solid ${vars.bright.status.info}`,
  borderRadius: vars.spacing.borderRadius.lg,
  backgroundColor: vars.surface.liquidGlass.innerSurface.background,
  animation: `${fadeInUp} ${vars.animation.duration.normal} ${vars.animation.easing.easeOut} both`,
  '@media': {
    [reducedMotion]: {
      animation: 'none',
    },
  },
});

export const content = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
  flex: 1,
  minWidth: 0,
});

export const title = style({
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.sm,
  fontWeight: String(vars.typography.fontWeight.semibold),
  color: vars.typography.textColor.primary,
  letterSpacing: vars.typography.letterSpacing.wide,
  lineHeight: String(vars.typography.lineHeight.snug),
});

export const body = style({
  margin: 0,
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.regular,
  color: vars.typography.textColor.secondary,
  letterSpacing: vars.typography.letterSpacing.wide,
  lineHeight: String(vars.typography.lineHeight.normal),
});

globalStyle(`${body} strong`, {
  color: vars.typography.textColor.primary,
  fontWeight: String(vars.typography.fontWeight.semibold),
});

export const dismissButton = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '28px',
  height: '28px',
  padding: 0,
  background: 'transparent',
  border: 'none',
  borderRadius: vars.spacing.borderRadius.sm,
  color: vars.typography.textColor.tertiary,
  cursor: 'pointer',
  selectors: {
    '&:hover': {
      color: vars.typography.textColor.secondary,
    },
    '&:focus-visible': {
      outline: `${vars.focus.ring.width} ${vars.focus.ring.style} ${vars.focus.ring.color}`,
      outlineOffset: vars.focus.ring.offset,
    },
  },
  '@media': {
    [mobile]: {
      minWidth: '44px',
      minHeight: '44px',
    },
  },
});
